// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as LoggerUtils$OrcaPaymentPage from "../Utilities/LoggerUtils.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "../Utilities/PaymentUtils.bs.js";
import * as CardValidations$OrcaPaymentPage from "../../shared-code/sdk-utils/validation/CardValidations.bs.js";
import * as EligibilityHelpers$OrcaPaymentPage from "../Utilities/EligibilityHelpers.bs.js";
import * as UseCardEligibility$OrcaPaymentPage from "./UseCardEligibility.bs.js";
import * as CardSchemeComponent$OrcaPaymentPage from "../CardSchemeComponent.bs.js";

function useCardForm(logger, paymentType, runEligibilityOpt, logControlEventsOpt, enableExternalCardSupportOpt, cardBrandOverrideOpt) {
  let runEligibility = runEligibilityOpt !== undefined ? runEligibilityOpt : true;
  let logControlEvents = logControlEventsOpt !== undefined ? logControlEventsOpt : true;
  let enableExternalCardSupport = enableExternalCardSupportOpt !== undefined ? enableExternalCardSupportOpt : false;
  let cardBrandOverride = cardBrandOverrideOpt !== undefined ? cardBrandOverrideOpt : "";
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  let localeString = match.localeString;
  let cardScheme = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.cardBrand);
  let showPaymentMethodsScreen = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.showPaymentMethodsScreen);
  let selectedOption = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.selectedOptionAtom);
  let paymentToken = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.paymentTokenAtom);
  let paymentMethodListValue = Jotai.useAtomValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  let forwardedSupportedCardBrands = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.supportedCardBrands);
  let match$1 = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.keys);
  let parentURL = match$1.parentURL;
  let match$2 = UseCardEligibility$OrcaPaymentPage.useCardEligibility(logger, runEligibility);
  let resetEligibilityState = match$2.resetEligibilityState;
  let triggerOnCardNumberChange = match$2.triggerOnCardNumberChange;
  let cardEligibilityError = match$2.cardEligibilityError;
  let match$3 = React.useState(() => "");
  let setCardNumber = match$3[1];
  let cardNumber = match$3[0];
  let match$4 = React.useState(() => "");
  let setCardExpiry = match$4[1];
  let cardExpiry = match$4[0];
  let match$5 = React.useState(() => "");
  let setCvcNumber = match$5[1];
  let cvcNumber = match$5[0];
  let match$6 = React.useState(() => "");
  let setZipCode = match$6[1];
  let zipCode = match$6[0];
  let match$7 = React.useState(() => "");
  let setCardError = match$7[1];
  let match$8 = React.useState(() => "");
  let setCvcError = match$8[1];
  let match$9 = React.useState(() => "");
  let setExpiryError = match$9[1];
  let match$10 = React.useState(() => false);
  let setDisplayPincode = match$10[1];
  let match$11 = React.useState(() => false);
  let setBlurState = match$11[1];
  let cardRef = React.useRef(null);
  let expiryRef = React.useRef(null);
  let cvcRef = React.useRef(null);
  let zipRef = React.useRef(null);
  let isCoBadgedCardDetectedOnce = React.useRef(false);
  let prevCardBrandRef = React.useRef("");
  let match$12 = React.useState(() => {});
  let setIsCardValid = match$12[1];
  let isCardValid = match$12[0];
  let match$13 = React.useState(() => {});
  let setIsExpiryValid = match$13[1];
  let isExpiryValid = match$13[0];
  let match$14 = React.useState(() => {});
  let setIsCVCValid = match$14[1];
  let isCVCValid = match$14[0];
  let match$15 = React.useState(() => {});
  let setIsZipValid = match$15[1];
  let match$16 = React.useState(() => {});
  let setIsCardSupported = match$16[1];
  let isCardSupported = match$16[0];
  let detectedCardBrand = CardUtils$OrcaPaymentPage.getCardBrand(cardNumber);
  let isNotBancontact = selectedOption !== "bancontact_card" && detectedCardBrand === "";
  let match$17 = React.useState(() => {
    if (!showPaymentMethodsScreen && isNotBancontact) {
      return cardScheme;
    } else {
      return detectedCardBrand;
    }
  });
  let setCardBrand = match$17[1];
  let cardBrand = match$17[0];
  let derivedCardBrand = CardUtils$OrcaPaymentPage.getCardBrandFromStates(cardBrand, cardScheme, showPaymentMethodsScreen);
  let cardBrand$1 = cardBrandOverride === "" ? derivedCardBrand : CardUtils$OrcaPaymentPage.normalizeCardBrand(cardBrandOverride);
  let cardBrandForCvc = cardBrand$1 === "" && paymentType === "Card" ? cardBrand : cardBrand$1;
  let maxCVCLength = CardValidations$OrcaPaymentPage.getobjFromCardPattern(cardBrandForCvc).maxCVCLength;
  let supportedCardBrands = React.useMemo(() => {
    if (forwardedSupportedCardBrands !== undefined) {
      return forwardedSupportedCardBrands;
    } else {
      return PaymentUtils$OrcaPaymentPage.getSupportedCardBrands(paymentMethodListValue);
    }
  }, [
    paymentMethodListValue,
    forwardedSupportedCardBrands
  ]);
  let maxCardLength = React.useMemo(() => CardUtils$OrcaPaymentPage.getMaxLength(cardBrand$1), [
    cardNumber,
    cardScheme,
    cardBrand$1,
    showPaymentMethodsScreen
  ]);
  React.useEffect(() => {
    if (!enableExternalCardSupport) {
      setIsCardSupported(param => PaymentUtils$OrcaPaymentPage.checkIsCardSupported(cardNumber, cardBrand$1, supportedCardBrands));
    }
  }, [
    supportedCardBrands,
    cardNumber,
    cardBrand$1,
    enableExternalCardSupport
  ]);
  let cardType = React.useMemo(() => CardUtils$OrcaPaymentPage.getCardType(cardBrand$1), [cardBrand$1]);
  React.useEffect(() => {
    if (cvcNumber.length > 0 && CardUtils$OrcaPaymentPage.cvcNumberInRange(cvcNumber, cardBrandForCvc).includes(true)) {
      setIsCVCValid(param => true);
    } else if (cvcNumber.length === 0) {
      setIsCVCValid(param => {});
    } else {
      setIsCVCValid(param => false);
    }
  }, [cardBrandForCvc]);
  React.useEffect(() => {
    if (CardUtils$OrcaPaymentPage.cvcNumberInRange(cvcNumber, cardBrandForCvc).includes(true) && cvcNumber.length === maxCVCLength) {
      CardUtils$OrcaPaymentPage.blurRef(cvcRef);
    }
  }, [
    cvcNumber,
    cardNumber
  ]);
  React.useEffect(() => {
    setCvcNumber(param => "");
    setCardExpiry(param => "");
    setIsExpiryValid(param => {});
    setIsCVCValid(param => {});
  }, [showPaymentMethodsScreen]);
  React.useEffect(() => {
    if (!isCoBadgedCardDetectedOnce.current) {
      setCvcNumber(param => "");
      setCardExpiry(param => "");
      setIsExpiryValid(param => {});
      setIsCVCValid(param => {});
    }
    prevCardBrandRef.current = cardBrand$1;
  }, [cardBrand$1]);
  React.useEffect(() => {
    setCvcNumber(param => "");
    setIsCVCValid(param => {});
    setCvcError(param => "");
    setCardError(param => "");
    setExpiryError(param => "");
  }, [
    paymentToken.paymentToken,
    showPaymentMethodsScreen
  ]);
  let changeCardNumber = ev => {
    let val = ev.target.value;
    LoggerUtils$OrcaPaymentPage.logInputChangeInfo("cardNumber", logger);
    let card = CardUtils$OrcaPaymentPage.formatCardNumber(val, cardType);
    let clearValue = CardValidations$OrcaPaymentPage.clearSpaces(card);
    let isCardSupportedAndValid = enableExternalCardSupport ? CardUtils$OrcaPaymentPage.cardValid(clearValue, cardBrand$1) && Core__Option.getOr(isCardSupported, false) : Core__Option.getOr(PaymentUtils$OrcaPaymentPage.checkIsCardSupported(clearValue, cardBrand$1, supportedCardBrands), false);
    CardUtils$OrcaPaymentPage.setCardValid(clearValue, cardBrand$1, setIsCardValid);
    if (CardUtils$OrcaPaymentPage.focusCardValid(clearValue, cardBrand$1) && isCardSupportedAndValid) {
      CardUtils$OrcaPaymentPage.handleInputFocus(cardRef, expiryRef);
    }
    if (card.length > 6 && CardUtils$OrcaPaymentPage.pincodeVisibility(cardBrand$1)) {
      setDisplayPincode(param => true);
    } else if (card.length < 8) {
      setDisplayPincode(param => false);
    }
    setCardNumber(param => card);
    if (card.length === 0 && prevCardBrandRef.current !== "") {
      setCvcNumber(param => "");
      setCardExpiry(param => "");
      setIsExpiryValid(param => {});
      setIsCVCValid(param => {});
      setIsCardValid(param => false);
    }
    triggerOnCardNumberChange(clearValue, isCardSupportedAndValid);
  };
  let changeCardExpiry = ev => {
    let val = ev.target.value;
    LoggerUtils$OrcaPaymentPage.logInputChangeInfo("cardExpiry", logger);
    let formattedExpiry = CardValidations$OrcaPaymentPage.formatCardExpiryNumber(val);
    if (CardUtils$OrcaPaymentPage.isExipryValid(formattedExpiry)) {
      CardUtils$OrcaPaymentPage.handleInputFocus(expiryRef, cvcRef);
      CardUtils$OrcaPaymentPage.emitExpiryDate(parentURL, formattedExpiry);
    }
    CardUtils$OrcaPaymentPage.setExpiryValid(formattedExpiry, setIsExpiryValid);
    setCardExpiry(param => formattedExpiry);
  };
  let changeCVCNumber = ev => {
    let val = ev.target.value;
    LoggerUtils$OrcaPaymentPage.logInputChangeInfo("cardCVC", logger);
    let cvc = CardValidations$OrcaPaymentPage.formatCVCNumber(val, cardBrandForCvc);
    setCvcNumber(param => cvc);
    if (cvc.length > 0 && CardUtils$OrcaPaymentPage.cvcNumberInRange(cvc, cardBrandForCvc).includes(true)) {
      Core__Option.forEach(Primitive_option.fromNullable(zipRef.current), input => {
        input.focus();
      });
    }
    if (cvc.length > 0 && CardUtils$OrcaPaymentPage.cvcNumberInRange(cvc, cardBrandForCvc).includes(true)) {
      return setIsCVCValid(param => true);
    } else {
      return setIsCVCValid(param => {});
    }
  };
  let changeZipCode = ev => {
    let val = ev.target.value;
    LoggerUtils$OrcaPaymentPage.logInputChangeInfo("zipCode", logger);
    setZipCode(param => val);
  };
  let onZipCodeKeyDown = ev => CardUtils$OrcaPaymentPage.commonKeyDownEvent(ev, zipRef, cvcRef, zipCode, cvcNumber, setCvcNumber);
  let onCvcKeyDown = ev => CardUtils$OrcaPaymentPage.commonKeyDownEvent(ev, cvcRef, expiryRef, cvcNumber, cardExpiry, setCardExpiry);
  let onExpiryKeyDown = ev => CardUtils$OrcaPaymentPage.commonKeyDownEvent(ev, expiryRef, cardRef, cardExpiry, cardNumber, setCardNumber);
  React.useEffect(() => {
    let handleFun = ev => {
      if (ev.source !== window.parent || parentURL !== "*" && ev.origin !== parentURL) {
        return;
      }
      let json = Utils$OrcaPaymentPage.safeParse(ev.data);
      let dict = Utils$OrcaPaymentPage.getDictFromJson(json);
      if (Core__Option.isSome(dict["doBlur"])) {
        if (logControlEvents) {
          logger.setLogInfo("doBlur Triggered", "BLUR", undefined, undefined, undefined, undefined, undefined);
        }
        return setBlurState(param => true);
      } else if (Core__Option.isSome(dict["doFocus"])) {
        if (logControlEvents) {
          logger.setLogInfo("doFocus Triggered", "FOCUS", undefined, undefined, undefined, undefined, undefined);
        }
        Core__Option.forEach(Primitive_option.fromNullable(cardRef.current), input => {
          input.focus();
        });
        return;
      } else if (Core__Option.isSome(dict["doClearValues"])) {
        if (logControlEvents) {
          logger.setLogInfo("doClearValues Triggered", "CLEAR", undefined, undefined, undefined, undefined, undefined);
        }
        setCardNumber(param => "");
        setCardExpiry(param => "");
        setCvcNumber(param => "");
        setIsCardValid(param => {});
        setCardError(param => "");
        setCvcError(param => "");
        setExpiryError(param => "");
        setIsExpiryValid(param => {});
        setIsCVCValid(param => {});
        return resetEligibilityState();
      } else {
        return;
      }
    };
    return Utils$OrcaPaymentPage.handleMessage(handleFun, "Error in parsing sent Data");
  }, []);
  let handleCardBlur = ev => {
    let cardNumber = ev.target.value;
    if (CardUtils$OrcaPaymentPage.cardNumberInRange(cardNumber, cardBrand$1).includes(true) && CardUtils$OrcaPaymentPage.calculateLuhn(cardNumber)) {
      if (enableExternalCardSupport) {
        return setIsCardValid(param => true);
      } else {
        return setIsCardValid(param => PaymentUtils$OrcaPaymentPage.checkIsCardSupported(cardNumber, cardBrand$1, supportedCardBrands));
      }
    } else if (cardNumber.length === 0) {
      return setIsCardValid(param => false);
    } else {
      return setIsCardValid(param => false);
    }
  };
  let handleExpiryBlur = ev => {
    let cardExpiry = ev.target.value;
    if (cardExpiry.length > 0 && CardUtils$OrcaPaymentPage.getExpiryValidity(cardExpiry)) {
      return setIsExpiryValid(param => true);
    } else if (cardExpiry.length === 0) {
      return setIsExpiryValid(param => {});
    } else {
      return setIsExpiryValid(param => false);
    }
  };
  let handleCVCBlur = ev => {
    let cvcNumber = ev.target.value;
    if (cvcNumber.length > 0 && CardUtils$OrcaPaymentPage.cvcNumberInRange(cvcNumber, cardBrandForCvc).includes(true)) {
      return setIsCVCValid(param => true);
    } else if (cvcNumber.length === 0) {
      return setIsCVCValid(param => {});
    } else {
      return setIsCVCValid(param => false);
    }
  };
  let handleZipBlur = ev => {
    let zipCode = ev.target.value;
    if (zipCode === "") {
      return setIsZipValid(param => false);
    } else {
      return setIsZipValid(param => true);
    }
  };
  React.useEffect(() => {
    let match = Core__Option.getOr(isCardSupported, true);
    let match$1 = Core__Option.getOr(isCardValid, true);
    let match$2 = cardNumber.length === 0;
    let cardError = cardEligibilityError !== undefined ? EligibilityHelpers$OrcaPaymentPage.getCardEligibilityErrorText(cardEligibilityError, localeString) : (
        match$2 ? "" : (
            match ? (
                match$1 ? "" : localeString.inValidCardErrorText
              ) : CardUtils$OrcaPaymentPage.getCardBrandInvalidError(cardBrand$1, localeString)
          )
      );
    let cardError$1 = Core__Option.isSome(isCardValid) ? cardError : "";
    setCardError(param => cardError$1);
  }, [
    isCardValid,
    isCardSupported,
    cardNumber,
    cardEligibilityError,
    cardBrand$1
  ]);
  React.useEffect(() => {
    setCvcError(param => {
      if (Core__Option.getOr(isCVCValid, true)) {
        return "";
      } else {
        return localeString.inCompleteCVCErrorText;
      }
    });
  }, [isCVCValid]);
  React.useEffect(() => {
    setExpiryError(param => {
      let match = CardUtils$OrcaPaymentPage.isExpiryComplete(cardExpiry);
      if (isExpiryValid !== undefined) {
        if (isExpiryValid) {
          if (match) {
            return "";
          } else {
            return localeString.inCompleteExpiryErrorText;
          }
        } else if (match) {
          return localeString.pastExpiryErrorText;
        } else {
          return localeString.inCompleteExpiryErrorText;
        }
      } else {
        return "";
      }
    });
  }, [
    isExpiryValid,
    CardUtils$OrcaPaymentPage.isExpiryComplete(cardExpiry)
  ]);
  React.useEffect(() => {
    let validCardBrand = CardUtils$OrcaPaymentPage.getFirstValidCardSchemeFromPML(cardNumber, Core__Option.getOr(supportedCardBrands, []));
    let newCardBrand = validCardBrand !== undefined ? validCardBrand : CardUtils$OrcaPaymentPage.getCardBrand(cardNumber);
    setCardBrand(param => newCardBrand);
  }, [cardNumber]);
  let icon = React.useMemo(() => JsxRuntime.jsx(CardSchemeComponent$OrcaPaymentPage.make, {
    cardNumber: cardNumber,
    paymentType: paymentType,
    cardBrand: cardBrand$1,
    setCardBrand: setCardBrand,
    isCoBadgedCardDetectedOnce: isCoBadgedCardDetectedOnce
  }), [
    cardType,
    paymentType,
    cardBrand$1,
    cardNumber
  ]);
  let cardProps_updateCardSupport = support => setIsCardSupported(param => support);
  let cardProps_cardError = match$7[0];
  let cardProps_updateCardEligibilityError = match$2.updateCardEligibilityError;
  let cardProps_eligibilitySurchargeDetails = match$2.eligibilitySurchargeDetails;
  let cardProps_eligibilityOfferDetails = match$2.eligibilityOfferDetails;
  let cardProps_isEligibilityPending = match$2.isEligibilityPending;
  let cardProps = {
    isCardValid: isCardValid,
    setIsCardValid: setIsCardValid,
    isCardSupported: isCardSupported,
    updateCardSupport: cardProps_updateCardSupport,
    cardNumber: cardNumber,
    changeCardNumber: changeCardNumber,
    handleCardBlur: handleCardBlur,
    cardRef: cardRef,
    icon: icon,
    cardError: cardProps_cardError,
    setCardError: setCardError,
    maxCardLength: maxCardLength,
    cardBrand: cardBrand$1,
    cardEligibilityError: cardEligibilityError,
    updateCardEligibilityError: cardProps_updateCardEligibilityError,
    eligibilitySurchargeDetails: cardProps_eligibilitySurchargeDetails,
    eligibilityOfferDetails: cardProps_eligibilityOfferDetails,
    isEligibilityPending: cardProps_isEligibilityPending
  };
  let expiryProps_expiryError = match$9[0];
  let expiryProps = {
    isExpiryValid: isExpiryValid,
    setIsExpiryValid: setIsExpiryValid,
    cardExpiry: cardExpiry,
    setCardExpiry: setCardExpiry,
    changeCardExpiry: changeCardExpiry,
    handleExpiryBlur: handleExpiryBlur,
    expiryRef: expiryRef,
    onExpiryKeyDown: onExpiryKeyDown,
    expiryError: expiryProps_expiryError,
    setExpiryError: setExpiryError
  };
  let cvcProps_cvcError = match$8[0];
  let cvcProps = {
    isCVCValid: isCVCValid,
    setIsCVCValid: setIsCVCValid,
    cvcNumber: cvcNumber,
    setCvcNumber: setCvcNumber,
    changeCVCNumber: changeCVCNumber,
    handleCVCBlur: handleCVCBlur,
    cvcRef: cvcRef,
    onCvcKeyDown: onCvcKeyDown,
    cvcError: cvcProps_cvcError,
    setCvcError: setCvcError,
    maxCVCLength: maxCVCLength
  };
  let zipProps_isZipValid = match$15[0];
  let zipProps_displayPincode = match$10[0];
  let zipProps = {
    isZipValid: zipProps_isZipValid,
    setIsZipValid: setIsZipValid,
    zipCode: zipCode,
    changeZipCode: changeZipCode,
    handleZipBlur: handleZipBlur,
    zipRef: zipRef,
    onZipCodeKeyDown: onZipCodeKeyDown,
    displayPincode: zipProps_displayPincode
  };
  return {
    cardProps: cardProps,
    expiryProps: expiryProps,
    cvcProps: cvcProps,
    zipProps: zipProps,
    blurState: match$11[0]
  };
}

export {
  useCardForm,
}
/* jotai Not a pure module */
